import React, { useContext, useState } from 'react';
import { IFindCallerObject, IPersonalDataObject } from '@vfit/shared/models';
import { LoggerInstance } from '@vfit/shared/data-access';
import { IProduct, updateProduct } from '@vfit/consumer/data-access';
import { ID_FLOWS, DEFAULT_CURRENT_STEP_KEY } from './CheckoutEnergy/checkoutEnergy.constants';
import { IEnergyContext, IEnergyProvider } from './energy.models';
import {
  DEFAULT_FIND_CALLER,
  DEFAULT_SLIDES_GO_BACK,
  DEFAULT_PRODUCT,
  DEFAULT_DATA,
} from './energy.context.data';

export const EnergyContext = React.createContext<IEnergyContext>({
  findCaller: DEFAULT_FIND_CALLER,
  slidesGoBack: DEFAULT_SLIDES_GO_BACK,
  currentStepKey: ID_FLOWS.PERSONAL_INFO,
  isModalButtonSticky: false,
  isDisabledBackButton: false,
  product: DEFAULT_PRODUCT as IProduct,
  owningData: DEFAULT_DATA,
  timerID: undefined,
  setOwningData: () => {
    return;
  },
  printContext: () => {
    return;
  },
  setFindCaller: () => {
    return;
  },
  setSlidesGoBack: () => {
    return;
  },
  setCurrentStepKey: () => {
    return;
  },
  setIsDisabledBackButton: () => {
    return;
  },
  setIsModalButtonSticky: () => {
    return;
  },
  setProduct: () => {
    return;
  },
  setTimerID: () => {
    return;
  }
});

export const EnergyProvider = ({ children }: IEnergyProvider) => {
  const [findCaller, setCaller] = useState<IFindCallerObject>({
    ...DEFAULT_FIND_CALLER,
  });

  const [slidesGoBack, setSlidesGoBackData] = useState<number>(DEFAULT_SLIDES_GO_BACK);

  const [currentStepKey, setCurrentStepKeyData] = useState<string>(DEFAULT_CURRENT_STEP_KEY);

  const [isModalButtonSticky, setIsModalButtonStickyStatus] = useState<boolean>(false);

  const [isDisabledBackButton, setisDisabledBackButtonStatus] = useState<boolean>(false);

  const [product, setProductData] = useState<IProduct>(DEFAULT_PRODUCT as IProduct);

  const [owningData, setCheckoutModalData] = useState<IPersonalDataObject>({
    ...DEFAULT_DATA,
  });

  const [timerID, setTimerIDData] = useState<NodeJS.Timeout>()

  const setFindCaller = (findCallerData: IFindCallerObject) => {
    setCaller({ ...findCallerData });
  };

  const setSlidesGoBack = (slidesBack: number) => {
    setSlidesGoBackData(slidesBack);
  };

  const setCurrentStepKey = (currentStepKeyLocal: string) => {
    setCurrentStepKeyData(currentStepKeyLocal);
  };

  const setIsModalButtonSticky = (isModalButtonStickyProps: boolean) => {
    setIsModalButtonStickyStatus(isModalButtonStickyProps);
  };

  const setIsDisabledBackButton = (isDisabledBackButtonProps: boolean) => {
    setisDisabledBackButtonStatus(isDisabledBackButtonProps);
  };
  const setOwningData = (checkoutData: IPersonalDataObject) => {
    setCheckoutModalData({ ...checkoutData });
  };
  const setProduct = (prodData: IProduct) => {
    updateProduct(prodData);
    setProductData(prodData);
  };

  const setTimerID = (timerIdData: NodeJS.Timeout) => {
    setTimerIDData(timerIdData);
  }

  const printContext = () => {
    LoggerInstance.info('context', {
      findCaller,
      slidesGoBack,
      currentStepKey,
      isModalButtonSticky,
      isDisabledBackButton,
      product,
      owningData,
    });
  };

  return (
    <EnergyContext.Provider
      //* eslint-disable-next-line react/jsx-no-constructed-context-values */
      value={{
        findCaller,
        setFindCaller,
        slidesGoBack,
        setSlidesGoBack,
        currentStepKey,
        setCurrentStepKey,
        printContext,
        isModalButtonSticky,
        setIsModalButtonSticky,
        product,
        setProduct,
        isDisabledBackButton,
        setIsDisabledBackButton,
        owningData,
        setOwningData,
        timerID,
        setTimerID,
      }}
    >
      {children}
    </EnergyContext.Provider>
  );
};

export const useEnergyCheckout = () => useContext(EnergyContext);
